<div
  class="card-body contacts_body p-0 dz-scroll"
  id="DZ_W_Contacts_Body1"
>
  <div>
    <div class="search-container">
      <input
        type="search"
        class="form-control border-0 p-3 pt-3 pe-5 pb-2 mb-1"
        [placeholder]="'common.search' | translate"
        [(ngModel)]="searchTerm">
      <i class="fa fa-search search-icon pt-2"></i>
    </div>
  </div>

  <ul class="contacts">
    <li class="name-first-letter unread-section">
      {{ "user-calls.last-calls" | translate }}
    </li>
    <li *ngFor="let item of lastCalls; let i = index" class="announcement-item">
      <div (click)="item?.card.status?.valueObject?.name?.value ? openCallCard(item) : openCall(item)" role="button"
        tabindex="-1">
    
        <div class="d-flex-between">
          <small>CA#{{ item?.id }}</small>
    
          <div class="d-flex align-items-center">
            <!-- NOTE -->
            <i *ngIf="item?.card?.note" class="fas fa-pen me-2 text-warning" [title]="item?.card?.note"
              style="cursor: pointer;" (click)="$event.stopPropagation()"></i>
    
            <span class="badge badge-sm badge-primary me-1">
              {{ item?.card.status?.valueObject?.name?.value }}
            </span>
    
            <small class="badge badge-sm badge-info" [class.badge-danger]="item.callType=='INBOUND'">
              {{ 'general.' + item.callType | translate }}
            </small>
    
          </div>
        </div>
    
        <div class="d-flex-between">
          <span class="announcement-title text-success">
            {{ item?.phone }}
    
            <app-call-button *ngIf="item?.phone" [class]="'btn btn-sm btn-success p-1 pb-0 pt-0'" [phone]="item?.phone">
            </app-call-button>
    
          </span>
    
          <p class="announcement-time text-primary">
            {{ item?.callStart | dateFormat:true }}
          </p>
        </div>
    
        <div class="d-flex-between" *ngIf="item?.card?.patient">
          <span class="announcement-title">
            {{ item?.card?.patient?.firstName }}
            {{ item?.card?.patient?.lastName }}
          </span>
        </div>
    
      </div>
    </li>
    <div
      *ngIf="this.lastCalls.length === 0"
      style="justify-content: center; align-items: center"
    >
      <app-empty-data
        [title]="
                    'user-calls.no-exist-last-calls' | translate
                  "
        icon="mdi mdi-information-outline"
        containerClass="opacity-50"
        iconSize="40px"
        iconColor="gray"
        titleSize="10px"
        titleColor="gray"
        messageSize="14px"
        messageColor="gray"
      >
      </app-empty-data>
    </div>
  </ul>
</div>
